import { render, staticRenderFns } from "./InstructionsForStarting.vue?vue&type=template&id=6c52d1c6&lang=pug"
import script from "./InstructionsForStarting.vue?vue&type=script&lang=js"
export * from "./InstructionsForStarting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports